import React from "react";
import OverviewHero from "./connector/overview-hero";
import ConnectionFlow from "./connector/connection-flow";
import ConnectionsList from "./connector/connections-list";

// Connections Overview screen (/connectors, /cdp/connections) — replaces
// the old full-screen "space background + single diagonal path" mockup
// with the real Sources/Destinations panel from the product design.
const AnimatedConnectionFlow: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-950 p-4 sm:p-6">
      <div className=" space-y-5">
        <div>
          <h1 className="text-lg sm:text-xl font-bold text-gray-900 dark:text-gray-100">Connections</h1>
          <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">
            Manage the sources that bring customer data into ConvoHub and the destinations where that data is
            activated.
          </p>
        </div>

        <OverviewHero />
        <ConnectionFlow />
        <ConnectionsList />
      </div>
    </div>
  );
};

export default AnimatedConnectionFlow;
